import React from "react";

const PriceGridCards = ({ data }) => {
  console.log(
    data !== undefined && data !== null && Object.keys(data).length > 0
  );


  const groups =
    data !== undefined && data !== null && Object.keys(data).length > 0   ? Object.keys(data)
      : [];

  const tiers =
    data !== undefined && data !== null && Object.keys(data).length > 0 && Object.keys(data[groups[0]]).length > 0   ? Object.keys(data[groups[0]])
      : []; // Assuming all groups have the same tiers

  // Let's arbitrarily highlight the second group as a 'featured' option
  // const featuredGroup = groups[1] || groups[0]; // If there's a second group, feature it, otherwise feature the first
  // const nonFeaturedGroups = groups.filter((group) => group !== featuredGroup);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 auto-rows-fr">
      {groups != undefined && groups !== null && groups.map((group) => (
        <div
          key={group}
          className="bg-white border-2 border-gray-200 p-8 flex flex-col justify-between"
        >
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              {group.charAt(0).toUpperCase() + group.slice(1).toLowerCase()}
            </h3>

            {tiers.map((tier) => (
              <div
                key={tier}
                className="border-t border-gray-200 py-4 flex items-center justify-between"
              >
                <span className="text-lg font-bold text-gray-800">
                  {tier.charAt(0).toUpperCase() + tier.slice(1).toLowerCase()}
                </span>

                <span className="text-2xl font-extrabold text-blue-700">
                  {data[group][tier].amount}{" "}
                  <span className="text-base text-gray-500">
                    {data[group][tier].currency}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Featured Card */}
      {/* <div
        key={featuredGroup}
        className="bg-gray-900 text-white border-2 border-blue-500 p-8 flex flex-col justify-between relative overflow-hidden"
      >
        <div className="absolute top-0 right-0 bg-blue-500 text-white text-xs font-bold px-3 py-1 -rotate-45 translate-x-4 -translate-y-2">
          MOST POPULAR
        </div>
        <div>
          <h3 className="text-3xl font-bold uppercase mb-4 text-blue-400">
            {featuredGroup}
          </h3>
          <p className="text-gray-300 text-sm mb-6">
            Unlock the full adventure with our premium {featuredGroup} package!
          </p>
          {tiers.map((tier) => (
            <div
              key={tier}
              className="border-t border-gray-700 py-4 flex items-center justify-between"
            >
              <span className="text-lg font-medium text-gray-100">{tier}</span>
              <span className="text-2xl font-extrabold text-blue-400">
                {data[featuredGroup][tier].amount}{" "}
                <span className="text-base text-gray-400">
                  {data[featuredGroup][tier].currency}
                </span>
              </span>
            </div>
          ))}
        </div>
        <button className="mt-8 w-full bg-blue-500 text-white py-3 font-semibold uppercase tracking-wider hover:bg-blue-600 transition-colors duration-300 border-none">
          Get Started
        </button>
      </div> */}
    </div>
  );
};

export default PriceGridCards;
